import React, { useEffect, useRef, useState } from 'react';

const LINKS = [
  { href: '#endorsement-title', label: 'Leaders' },
  { href: '#timeline-title', label: 'Momentum' },
  { href: '#value-prop-title', label: 'Coverage' },
  { href: '#explore-cta-title', label: 'Explore' },
];

export function StickyHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 120);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (!menuOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    const onClick = (e: MouseEvent) => {
      if (!panelRef.current) return;
      if (!panelRef.current.contains(e.target as Node)) setMenuOpen(false);
    };
    document.addEventListener('keydown', onKey);
    document.addEventListener('mousedown', onClick);
    return () => {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('mousedown', onClick);
    };
  }, [menuOpen]);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    const target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    setMenuOpen(false);
    const y = (target as HTMLElement).getBoundingClientRect().top + window.scrollY - 72;
    window.scrollTo({ top: y, behavior: 'smooth' });
  };

  return (
    <header className={`sticky-header${scrolled ? ' sticky-header--scrolled' : ''}`} role="banner">
      <nav className="sticky-header__inner" aria-label="Primary">
        <a
          href="#hero-title"
          className="sticky-header__brand"
          onClick={(e) => handleClick(e, '#hero-title')}
          aria-label="Bilateral Navigator home"
        >
          <img
            src="/brand/compass.svg"
            alt=""
            className="sticky-header__compass"
            width={28}
            height={28}
          />
          <span className="sticky-header__wordmark">Bilateral Navigator</span>
        </a>
        <ul className="sticky-header__links">
          {LINKS.map((l) => (
            <li key={l.href}>
              <a href={l.href} onClick={(e) => handleClick(e, l.href)}>
                {l.label}
              </a>
            </li>
          ))}
        </ul>
        <button
          type="button"
          className="sticky-header__hamburger"
          aria-expanded={menuOpen}
          aria-controls="sticky-menu"
          aria-label="Menu"
          onClick={() => setMenuOpen((o) => !o)}
        >
          <span />
          <span />
          <span />
        </button>
      </nav>
      {menuOpen && (
        <div id="sticky-menu" ref={panelRef} className="sticky-header__panel" role="menu">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              role="menuitem"
              onClick={(e) => handleClick(e, l.href)}
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
